import { ready, createComponent } from '@/shared'
import { renderProductsListRatings } from '@/modules'
import { renderTruncate } from '@/modules/truncate'
import { renderWishlist } from '@/modules/wishlist'
import { renderCategories } from '@/modules/categories'
import ProductListNotification from '@/components/ProductListNotification/ProductListNotification.vue'

const getProductIdsFromDom = () => {
  return Array
    .from(document.querySelectorAll('.js-productlist-notification-data'))
    .map(element => element.getAttribute('data-id'))
}

function renderProductsListNotification () {
  const urlWrap = document.querySelector('#js-productlist-notification-url')
  if (urlWrap !== null) {
    const urlProduct = urlWrap.getAttribute('data-url-add')
    const products = getProductIdsFromDom()
    products.forEach(function (product) {
      const selector = ['.js-productlist-notification[data-id="', product, '"]'].join('')
      let productListItem = document.querySelector('.js-notification-open-list' + product).parentElement.parentElement
      let urlImage = productListItem.querySelector('.front-image img').getAttribute('data-src')
      createComponent(document.querySelector(selector), ProductListNotification, {
        urlImage: urlImage,
        idProduct: product,
        urlProduct: urlProduct
      })
    })
  }
}

function renderRatings () {
  renderProductsListRatings()
}

ready(function () {
  renderTruncate()
  renderRatings()
  renderWishlist()
  renderCategories()
  renderProductsListNotification()

  const bodyElement = document.querySelector('body')
  bodyElement.addEventListener('productsListLoaded', () => renderRatings())

  // new Vue({ // eslint-disable-line no-new
  //   el: '#js-product-notification',

  //   components: {
  //     ProductListNotification
  //   },

  //   render: h => h('ProductListNotification')
  // })
})



// WEBPACK FOOTER //
// ./src/product-list.js